function SocialChannel1() {
  return (
    <svg
      width={198}
      height={70}
      viewBox="0 0 198 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path opacity="0.3" d="M15 16L45.9452 53H111.507H197" stroke="#242536" />
      <path opacity="0.3" d="M1 32L32.0165 69H97.7296H196" stroke="#242536" />
      <path d="M25 1L55.9257 38H121.446H198" stroke="#242536" strokeOpacity="0.6" />
      <path d="M25 1L55.9257 38H121.446H198" stroke="url(#paint0_linear_2018_45)" />
      <defs>
        <linearGradient
          id="paint0_linear_2018_45"
          x1={25}
          y1="19.5"
          x2="257.159"
          y2="18.0973"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0674891" stopColor="#368DFF" stopOpacity={0} />
          <stop offset="0.206121" stopColor="#368DFF" />
          <stop offset="0.207969" stopColor="#368DFF" stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>

  );
}

export default SocialChannel1;